import React, { useEffect, useState, useRef, useContext } from 'react';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Multiselect from 'multiselect-react-dropdown';
import DropDown from '@shared/component/DropDown';
import axios from 'axios';
import CheckValidator from '@shared/checkValidator';
import MultiSelect from '@shared/component/MultiSelect';
import { useJwt } from 'react-jwt';
import Chip from '@shared/component/chip';
import { imageCompress } from '@utils/static/commonUtils';

export function VendoRegistrationOther() {
    const [errors, setError] = useState<any>({
        pincode: {
            required: true,
            error: true,
            message: 'Please enter pincode',
            pattern: /^(\d{6})$/,
            maxLength: 6,
        },
        state: {
            required: true,
            error: false,
            message: 'Please enter state',
            maxLength: 20,
            readOnly: true,
        },
        city: {
            required: true,
            error: true,
            message: 'Please select city',
            maxLength: 20,
        },
        address: {
            required: true,
            error: true,
            message: 'Please enter address',
            maxLength: 60,
        },
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z0-9\s.]*$/,
            maxLength: 50,
            readOnly: true,
        },
        company_name: {
            required: true,
            error: false,
            message: 'Please enter company name',
            pattern: /^[\w\s&.'-]+$/u,
            maxLength: 50,
            readOnly: true,
        },
        phone: {
            required: true,
            error: false,
            message: 'Please enter phone number',
            pattern: /^[6-9]{1}[0-9]{9}$/,
            maxLength: 10,
            readOnly: true,
        },
        email: {
            required: true,
            error: true,
            message: 'Please enter email',
            pattern: /^\S+@\S+\.\S+$/,
            maxLength: 50,
        },
    });

    const [errors2, setError2] = useState<any>({
        // vehicle_no: {
        //     required: true,
        //     error: true,
        //     message: 'Please enter vehicle number',
        //     pattern: /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/,
        //     maxLength: 10
        // },
        gst: {
            required: true,
            error: true,
            pattern: /^[0-9A-Za-z]{15}$/,
            message: 'Please enter GST no.',
            maxLength: 15,
        },
        pan: {
            required: true,
            error: true,
            pattern: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
            message: 'Please enter PAN no.',
            maxLength: 10,
        },
        aadhar_no: {
            required: true,
            error: true,
            pattern: /^[0-9]{12}$/,
            message: 'Please enter aadhar no.',
            maxLength: 12,
        },
        aadhar: {
            required: true,
            error: true,
            message: 'Please upload aadhaar card',
        },
        gstDoc: {
            required: true,
            error: true,
            message: 'Please upload GST',
        },
        panDoc: {
            required: true,
            error: true,
            message: 'Please upload PAN card',
        },
        other: {
            required: false,
            error: false,
            message: 'Please upload',
        },
    });
    const [pincodeerror, setPincodeError] = useState('');
    const [showPincodeError, setshowPincodeError] = useState(false);
    const [showLoader, setLoader] = useState(false);
    // const { setLoader } = useContext(AuthContext)
    const [activeTab, setActiveTab] = useState('one');
    const [completeTab, setcompleteTab] = useState<any[]>([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [formData, setFormData] = useState<any>({
        name: null,
        phone: null,
        address: null,
        pincode: null,
        state: null,
        city: null,
        email: null,
        gst: null,
        pan: null,
        aadhar_no: null,
        aadhar: null,
        gstDoc: null,
        panDoc: null,
        other: null,
    });
    const navigate = useNavigate();
    const token: any = useParams();
    const { decodedToken, isExpired } = useJwt(token.token);
    const [validate, setValidate] = useState(true);
    const [getdata, setgetData] = useState(false);
    const [number, setNumber] = useState('');
    const [city, setCity] = useState<any>([]);
    const [showLinkExpBtn, setshowLinkExpBtn] = useState(false);

    const checkregistration = async () => {
        try {
            setgetData(false);
            setValidate(true);
            setLoader(true);

            const updateddata = await APIService.getAll('validate', true, false, token.token);
            setLoader(false);
            if (updateddata.status === 200) {
                setTimeout(() => {
                    setValidate(true);
                    setgetData(true);
                }, 3000);

                setFormData({
                    ...formData,
                    ['phone']: updateddata.data.data.phone,
                    ['name']: updateddata.data.data.name,
                    ['company_name']: updateddata.data.data.companyname,
                    ['items']: updateddata?.data?.item,
                    ['category']: updateddata.data.data.category.name,
                    ['email']: updateddata?.data?.data?.email,
                    ['pincode']: updateddata?.data?.data?.other_document?.pincode,
                    ['city']: updateddata?.data?.data?.other_document?.city,
                    ['address']: updateddata?.data?.data?.other_document?.address,
                    ['gst']: updateddata?.data?.data?.other_document?.gstNo,
                    ['pan']: updateddata?.data?.data?.other_document?.panNo,
                    ['aadhar_no']: updateddata?.data?.data?.other_document?.aadharNo,
                });
            } else if (updateddata.status === 203) {
                setValidate(false);
                setgetData(false);
                setshowLinkExpBtn(true);
            } else {
                setTimeout(() => {
                    setValidate(false);
                    setgetData(false);
                }, 3000);
                setNumber(updateddata.data.data);
            }
        } catch (err) {
            setTimeout(() => {
                setValidate(false);
                setgetData(false);
            }, 3000);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        setLoader(true);
        checkregistration();
    }, []);

    const clickButton = (tab: string, tab2?: any) => {
        try {
            setActiveTab(tab);
            setcompleteTab([...completeTab, tab2]);
        } catch (error) {}
    };

    const checkpincode = async (code: any) => {
        try {
            setLoader(true);
            const data = await axios(`https://api.postalpincode.in/pincode/${code}`);
            setLoader(false);
            if (data?.data?.[0]?.Status == 'Error' || data?.data?.[0]?.Status == '404') {
                setPincodeError('Please enter valid pincode');
                Notify('error', data?.data?.[0]?.Message || 'Please enter valid pincode');

                setFormData({ ...formData, pincode: null, state: '', city: null });
                setCity([]);
                setshowPincodeError(true);
            } else {
                const uniqueDistrictsArray: { district: string }[] = [
                    ...new Set(data.data[0].PostOffice.map((post: any) => post.District)),
                ].map((District: string) => ({ District }));
                setCity(uniqueDistrictsArray);
                setFormData({ ...formData, ['state']: data.data[0].PostOffice[0].State, ['pincode']: code });
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getValue = (e: any) => {
        try {
            setshowPincodeError(false);

            if (e.pincode !== undefined && errors.pincode.pattern.test(e?.pincode?.trim())) {
                if (e?.pincode?.length > 5) {
                    checkpincode(e?.pincode);
                }
            } else if (e.pincode === null) {
                e = { pincode: null, state: '', city: '' };
                setCity([]);
            }
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };

    const submit = async () => {
        try {
            const data = {
                idProof: formData?.aadhar,
                gstDoc: formData?.gstDoc,
                panDoc: formData?.panDoc,
                other: formData?.other,
                name: formData?.name,
                // vehicle: formData?.rc,
                // vehicleNumber: formData?.vehicle_no,
                // vehicleCompany: formData?.vehicle_company,
                // vehicleModel: formData?.vehicle_modal,
                // vehicleCapacity: formData?.vehicle_capacity,
                address: formData?.address,
                pincode: formData?.pincode,
                state: formData?.state,
                city: formData?.city,
                email: formData?.email,
                gstNo: formData?.gst,
                panNo: formData?.pan,
                aadharNo: formData?.aadhar_no,
            };

            // return;
            setLoader(true);
            const updateddata = await APIService.update('app/user/OtherDocument', token.token, data, false, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Vendor Registration successfully');
                setActiveTab('finish');
                setTimeout(() => {
                    navigate('/');
                }, 4000);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const handlefile = async (files: FileList | null, type: any, e: any) => {
        try {
            if (files && files.length > 0) {
                const fileObj = files[0];

                // Check file size (5MB limit)
                const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                if (!allowedTypes.includes(fileObj.type)) {
                    Notify('error', 'Invalid file format. Please choose a JPG, JPEG, PNG, or PDF file.');
                    e.target.value = null;

                    return;
                }
                if (fileObj.size > maxSize) {
                    Notify('error', 'File size must be less than 5 mb.');
                    e.target.value = null;
                    // Reset in case of Error
                    if (type == 'other') {
                        setFormData({ ...formData, ['other']: null, ['otherfile']: undefined });
                    }
                    return;
                }

                const file: any = await imageCompress(fileObj);

                if (type == 'aadhar') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['aadhar']: file,
                                ['aadharfile']: file.name,
                                ['aadharpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else if (type == 'panDoc') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['panDoc']: file,
                                ['panfile']: file.name,
                                ['panpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else if (type == 'gstDoc') {
                    const reader = new FileReader();

                    reader.addEventListener(
                        'load',
                        () => {
                            // convert image file to base64 string
                            setFormData({
                                ...formData,
                                ['gstDoc']: file,
                                ['gstfile']: file.name,
                                ['gstpreview']: reader.result,
                            });
                        },
                        false,
                    );

                    if (file) {
                        reader.readAsDataURL(file);
                    }
                } else {
                    setFormData({ ...formData, ['other']: file, ['otherfile']: file.name });
                }
                errors2[type]['error'] = false;

                setError2(errors2);
            }
        } catch (error) {}
    };
    const next2 = async (type: any) => {
        if (type == 'one') {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            if (isValid) {
                clickButton('two', 'one');
            }
            return;
        } else if (type == 'two') {
            const isValid = await CheckValidator(errors2, formData);
            setIsSubmit(!isValid);
            if (isValid) {
                submit();
            }
        }
    };
    const requestnewlink = async () => {
        try {
            resendLink(decodedToken);
            return;
        } catch (error) {
            setLoader(false);
        }
    };

    const resendLink = async (e: any) => {
        try {
            const { name, phone, id, companyname } = e;
            const data = {
                name: name,
                phone: phone,
                companyname: companyname,
                id: id,
            };

            setLoader(true);
            const updateddata = await APIService.post('user/request', data, false, false);
            setLoader(false);
            Notify('success', 'Link sent successfully');
            setTimeout(() => {
                navigate('/');
            }, 3000);
        } catch (error) {
            setLoader(false);
        }
    };

    const handleitem = (data: any) => {
        const d = data.map((i: any) => {
            return { id: i.id, name: i.name };
        });
        setFormData({ ...formData, ['items']: d });
    };

    const getMultiSelectValue = (e: any) => {
        try {
            getValue({ items: e });
            // errors['userIds']['error'] = false;
            // setError(errors)
        } catch (error) {}
    };

    return (
        <>
            <header>
                <div className="main_header outer_header_cover">
                    {showLoader && <div className="loader"></div>}
                    <nav className="navbar">
                        <div className="container">
                            <div className="logo_sec_box">
                                <NavLink
                                    to={`/vendor_registration/${token.token}/${token.item}/${token.category}`}
                                    className="navbar-brand"
                                >
                                    <img className="logo_box img-fluid" src="assets/images/ebidding_logo.svg" alt="" />
                                </NavLink>
                            </div>
                            <div className="main_navbar_cover">
                                <nav className="navbar navbar-expand-lg">
                                    <ul className="navbar-nav">
                                        <li className="nav-item">
                                            <a className="nav-link" href="#">
                                                Facing any issues ?
                                            </a>
                                        </li>
                                        <li className="nav-item last_link">
                                            <div className="dropdown user_drop">
                                                <button
                                                    className="btn custom_btn dark_border_btn next_btn dropdown-toggle"
                                                    style={{
                                                        color: '#1e1e1e',
                                                        backgroundColor: 'white',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        borderRadius: '8px',
                                                        border: '1px solid #e8e9ec',
                                                        padding: ' 8px 12px 10px',
                                                        borderColor: '#000',
                                                        width: '100%',
                                                    }}
                                                    type="button"
                                                    id="user_box_drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    Contact Us
                                                </button>
                                                <ul className="dropdown-menu" aria-labelledby="user_box_drop">
                                                    <li className="user_profile_box">
                                                        {/* <div className="user_img">{user ? user.name.charAt(0).toUpperCase() : 'A'}</div> */}
                                                        <div className="user_info">
                                                            <p>
                                                                Email:{' '}
                                                                <a href="mailto:support@nordemtech.com">
                                                                    <b>Support@nordemtech.com</b>
                                                                </a>
                                                            </p>
                                                            <p>
                                                                Contact No:{' '}
                                                                <a href="tel:1234567890">
                                                                    <b>1234567890</b>
                                                                </a>
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            {/* <a className="btn custom_btn dark_border_btn next_btn" aria-current="page" href="#">Contact Us</a> */}
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            <main>
                <div className="vendor_registration_Form_cover multi_step_form   form_outer_bg">
                    <div className="form_box_cover">
                        {validate ? (
                            <>
                                {getdata ? (
                                    <>
                                        <div className="upper_box">
                                            <h2>
                                                <span className="mat_icon material-symbols-outlined">group</span> Vendor
                                                Registration Form{' '}
                                                {activeTab != 'finish'
                                                    ? activeTab == 'one'
                                                        ? 1
                                                        : activeTab == 'two'
                                                        ? 2
                                                        : 3
                                                    : ''}
                                            </h2>
                                            {activeTab != 'finish' ? (
                                                <div className="step_nav_box">
                                                    <div
                                                        className={`step_box step_one_box ${
                                                            activeTab == 'one' ? 'done_box active_box' : null
                                                        } ${
                                                            completeTab.includes('one') ? 'done_box finished_box' : null
                                                        }`}
                                                    >
                                                        <h3>1</h3>
                                                        {activeTab == 'one' ? <span>Personal Details</span> : ''}
                                                    </div>
                                                    <div
                                                        className={`step_box step_two_box ${
                                                            activeTab == 'two' ? 'active_box' : null
                                                        } ${
                                                            completeTab.includes('two') ? 'done_box finished_box' : null
                                                        }`}
                                                    >
                                                        <h3>2</h3>
                                                        {activeTab == 'two' ? <span>Document Verification</span> : ''}
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        <div className="material_form_cover">
                                            <form>
                                                <div
                                                    className={
                                                        activeTab == 'one'
                                                            ? 'active_step_box'
                                                            : ' ' + 'step_box step_box_one'
                                                    }
                                                >
                                                    <div className="field_box">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'Company name',
                                                                            name: 'name',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="company_name"
                                                                        isSubmit={isSubmit}
                                                                        value={formData.company_name}
                                                                        errorMsg={errors?.company_name.message}
                                                                        inputProps={errors}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'number',
                                                                            placeholder: 'Mobile Number',
                                                                            name: 'phone',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="phone"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors?.phone.message}
                                                                        inputProps={errors}
                                                                        value={formData.phone || ''}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'Full Name',
                                                                            name: 'name',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="name"
                                                                        isSubmit={isSubmit}
                                                                        value={formData.name}
                                                                        errorMsg={errors?.name.message}
                                                                        inputProps={errors}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'Email',
                                                                            name: 'email',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="email"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors?.email.message}
                                                                        inputProps={errors}
                                                                        value={formData?.email}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'number',
                                                                            placeholder: 'Pincode',
                                                                            name: 'pincode',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="pincode"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors?.pincode.message}
                                                                        inputProps={errors}
                                                                        value={formData?.pincode}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />

                                                                    {showPincodeError && isSubmit && (
                                                                        <div
                                                                            className="text-danger ft-12"
                                                                            style={{ marginTop: '-30px' }}
                                                                        >
                                                                            {' '}
                                                                            {'Invalid Pincode'}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'State',
                                                                            name: 'state',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="state"
                                                                        isSubmit={isSubmit}
                                                                        value={formData?.state}
                                                                        setValue={(e: any) => getValue(e)}
                                                                        errorMsg={errors?.state.message}
                                                                        inputProps={errors}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <DropDown
                                                                        data={{
                                                                            placeholder: 'Select City',
                                                                            name: 'city',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="city"
                                                                        displayName={'District'}
                                                                        optionValue={'District'}
                                                                        isSubmit={isSubmit}
                                                                        value={formData.city}
                                                                        options={city}
                                                                        setValue={(e: any) => getValue(e)}
                                                                        errorMsg={errors?.city.message}
                                                                        inputProps={errors}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-sm-12">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'Full Address',
                                                                            name: 'address',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        isRequired={true}
                                                                        controlName="address"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors?.address.message}
                                                                        inputProps={errors}
                                                                        value={formData?.address}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span>Item Details</span>
                                                    <br />
                                                    <br />
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-floating">
                                                                <TextInput
                                                                    data={{
                                                                        type: 'text',
                                                                        placeholder: 'Category',
                                                                        name: 'catgegory',
                                                                        id: 'floatingInput',
                                                                    }}
                                                                    readOnly={true}
                                                                    isRequired={true}
                                                                    controlName="Category"
                                                                    isSubmit={isSubmit}
                                                                    errorMsg="Please enter valid category"
                                                                    value={formData.category}
                                                                    setValue={(e: any) => getValue(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-floating chip_float_label_box">
                                                                {/* <Multiselect
                                                                    disable={true}
                                                                    options={formData.items}
                                                                    selectedValues={formData.items || []}
                                                                    onSelect={handleitem}
                                                                    onRemove={handleitem}
                                                                    displayValue="name"
                                                                    placeholder="Select Item"
                                                                /> */}

                                                                <Chip label="items" item={formData.items} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="footer_form_box">
                                                        <button
                                                            type="button"
                                                            className="btn custom_btn fill_btn next_btn"
                                                            onClick={() => next2('one')}
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>

                                                <div
                                                    className={
                                                        activeTab == 'two'
                                                            ? 'active_step_box'
                                                            : ' ' + 'step_box step_box_two'
                                                    }
                                                >
                                                    <div className="field_box">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'GST',
                                                                            name: 'gst',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="gst"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.gst.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.gst}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('gstDoc')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.gstfile ? (
                                                                                formData.gstfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf)Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            id="gstDoc"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'gstDoc', e);
                                                                            }}
                                                                        />

                                                                        {errors2?.gstDoc?.required &&
                                                                            errors2?.gstDoc?.error &&
                                                                            isSubmit && (
                                                                                <div
                                                                                    className="text-danger ft-12 "
                                                                                    style={{ marginTop: '12px' }}
                                                                                >
                                                                                    {' '}
                                                                                    {errors2?.gstDoc.message}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                {formData?.gstfile ? (
                                                                    <div>
                                                                        {formData?.gstfile?.split('.')[1] != 'png'}
                                                                        {formData?.gstfile?.split('.')[1] != 'jpeg' &&
                                                                        formData?.gstfile.split('.')[1] != 'jpg' &&
                                                                        formData?.gstfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.gstpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.gstfile !== undefined
                                                                                ? formData.gstfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src="./assets/images/registrationform.svg"
                                                                            className="img-fluid"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'text',
                                                                            placeholder: 'PAN',
                                                                            name: 'pan',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="pan"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.pan.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.pan}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('panDoc')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.panfile !== undefined ? (
                                                                                formData.panfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf)Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            id="panDoc"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'panDoc', e);
                                                                            }}
                                                                        />
                                                                        {errors2?.panDoc?.required &&
                                                                            errors2?.panDoc?.error &&
                                                                            isSubmit && (
                                                                                <div
                                                                                    className="text-danger ft-12"
                                                                                    style={{ marginTop: '12px' }}
                                                                                >
                                                                                    {' '}
                                                                                    {errors2?.panDoc.message}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                {formData?.panfile !== undefined ? (
                                                                    <div>
                                                                        {formData?.panfile?.split('.')[1] != 'png'}
                                                                        {formData?.panfile?.split('.')[1] != 'jpeg' &&
                                                                        formData?.panfile.split('.')[1] != 'jpg' &&
                                                                        formData?.panfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.panpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.panfile !== undefined
                                                                                ? formData.panfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src="./assets/images/registrationform.svg"
                                                                            className="img-fluid"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <TextInput
                                                                        data={{
                                                                            type: 'number',
                                                                            placeholder: 'Aadhar',
                                                                            name: 'aadhar_no',
                                                                            id: 'floatingInput',
                                                                        }}
                                                                        controlName="aadhar_no"
                                                                        isSubmit={isSubmit}
                                                                        errorMsg={errors2?.aadhar_no.message}
                                                                        inputProps={errors2}
                                                                        value={formData?.aadhar_no}
                                                                        setValue={(e: any) => getValue(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-floating">
                                                                    <div
                                                                        className="form-control"
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            cursor: 'pointer',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e8e9ec',
                                                                        }}
                                                                        onClick={() => {
                                                                            document.getElementById('aadhar')?.click();
                                                                        }}
                                                                    >
                                                                        <span className="drop-zone__prompt">
                                                                            {' '}
                                                                            {formData?.aadharfile !== undefined &&
                                                                            formData?.aadharfile !== null ? (
                                                                                formData.aadharfile
                                                                            ) : (
                                                                                <>
                                                                                    <span
                                                                                        className="d-flex"
                                                                                        style={{
                                                                                            justifyContent:
                                                                                                'space-between',
                                                                                            flexDirection: 'row',
                                                                                        }}
                                                                                    >
                                                                                        Upload Document (.jpg, .png,
                                                                                        .pdf)Max size: 5MB
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                        <input
                                                                            type="file"
                                                                            name="myFile"
                                                                            className="drop-zone__input"
                                                                            accept=".jpeg, .jpg, .png, .pdf"
                                                                            id="aadhar"
                                                                            onChange={e => {
                                                                                handlefile(e.target.files, 'aadhar', e);
                                                                            }}
                                                                        />
                                                                        {errors2?.aadhar?.required &&
                                                                            errors2?.aadhar?.error &&
                                                                            isSubmit && (
                                                                                <div
                                                                                    className="text-danger ft-12"
                                                                                    style={{ marginTop: '12px' }}
                                                                                >
                                                                                    {' '}
                                                                                    {errors2?.aadhar.message}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                {formData?.aadharfile !== undefined &&
                                                                formData?.aadharfile !== null ? (
                                                                    <div>
                                                                        {formData?.aadharfile?.split('.')[1] != 'png'}
                                                                        {formData?.aadharfile?.split('.')[1] !=
                                                                            'jpeg' &&
                                                                        formData?.aadharfile.split('.')[1] != 'jpg' &&
                                                                        formData?.aadharfile.split('.')[1] != 'png' ? (
                                                                            <div className="vendorpdf">
                                                                                <img
                                                                                    src="./assets/images/pdficon.svg"
                                                                                    className="img-fluid"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="vendorimage">
                                                                                <img
                                                                                    src={formData?.aadharpreview}
                                                                                    className="img-fluid w-100 h-100"
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className="vendorpdftext"
                                                                            style={{ marginBottom: '30px' }}
                                                                        >
                                                                            {formData?.aadharfile !== undefined
                                                                                ? formData.aadharfile
                                                                                : 'Upload file'}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className="vendorform"
                                                                        style={{ marginBottom: '30px' }}
                                                                    >
                                                                        <img
                                                                            src="./assets/images/registrationform.svg"
                                                                            className="img-fluid"
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="field_box">
                                                                <h3>Other Certificate / Document (Optional)</h3>
                                                                <div className="row">
                                                                    <div className="col-sm-12">
                                                                        <div
                                                                            className="drop-zone"
                                                                            onClick={() => {
                                                                                document
                                                                                    .getElementById('other')
                                                                                    ?.click();
                                                                            }}
                                                                        >
                                                                            {formData?.otherfile !== undefined ? (
                                                                                formData.otherfile
                                                                            ) : (
                                                                                <>
                                                                                    {' '}
                                                                                    <span className="drop-zone__prompt">
                                                                                        {' '}
                                                                                        <span className="material-symbols-outlined">
                                                                                            upload
                                                                                        </span>{' '}
                                                                                        Drop any attachment here(Max
                                                                                        size: 5MB)
                                                                                    </span>
                                                                                </>
                                                                            )}
                                                                            <input
                                                                                type="file"
                                                                                name="myFile"
                                                                                className="drop-zone__input"
                                                                                id="other"
                                                                                accept=".jpeg, .jpg, .png, .pdf"
                                                                                onChange={e => {
                                                                                    handlefile(
                                                                                        e.target.files,
                                                                                        'other',
                                                                                        e,
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="footer_form_box">
                                                        <button
                                                            type="button"
                                                            className="btn custom_btn border_btn prev_btn"
                                                            onClick={() => clickButton('one')}
                                                        >
                                                            Back
                                                        </button>
                                                        &nbsp;&nbsp;
                                                        <button
                                                            type="button"
                                                            className="btn custom_btn fill_btn submit_form_btn"
                                                            onClick={() => next2('two')}
                                                            style={{ marginRight: '10px' }}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>

                                                <div
                                                    className={
                                                        activeTab == 'finish'
                                                            ? 'active_step_box'
                                                            : ' ' + 'step_box step_box_finish'
                                                    }
                                                >
                                                    <div
                                                        className="finish_anime_box"
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            flexDirection: 'column',
                                                        }}
                                                    >
                                                        <lottie-player
                                                            src="https://lottie.host/5d599fe9-fcb8-444d-a263-52681efe1ef2/uXqsayc0GH.json"
                                                            background="##fff"
                                                            speed="1"
                                                            style={{ width: '200px', height: '200px' }}
                                                            loop
                                                            autoplay
                                                            direction="1"
                                                            mode="normal"
                                                        ></lottie-player>

                                                        <h6 className="textvendor">
                                                            {number == ''
                                                                ? 'Application Submitted Successfully!'
                                                                : 'New Link Request Submitted'}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        className="upper_box"
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <lottie-player
                                            src="https://lottie.host/c8fdbc0a-47c3-4e05-9ed6-45feade0bac9/XhjFkYl2fu.json"
                                            background="##fff"
                                            speed="1"
                                            style={{ width: '300px', height: '300px' }}
                                            loop
                                            autoplay
                                            direction="1"
                                            mode="normal"
                                        ></lottie-player>

                                        <h6 className="textvendor">Validating your profile</h6>
                                        <img src="assets/images/loader.svg" className="img-fluid" />
                                        <br />
                                    </div>
                                )}
                            </>
                        ) : showLinkExpBtn ? (
                            <div className="upper_box">
                                <h2>
                                    <span className="mat_icon material-symbols-outlined">group</span> Vendor
                                    Registration Form{' '}
                                </h2>

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <lottie-player
                                        src="https://lottie.host/66b03ae5-ad9c-45f9-95f0-330413ee76fe/fZXsnvWuk6.json"
                                        background="##fff"
                                        speed="1"
                                        style={{ width: '100px', height: '100px' }}
                                        loop
                                        autoplay
                                        direction="1"
                                        mode="normal"
                                    ></lottie-player>
                                    <h6 className="textvendor">
                                        This link has been expired.. Click below to request new link..
                                    </h6>
                                    <button
                                        className="requestvendor btn"
                                        onClick={() => {
                                            requestnewlink();
                                        }}
                                    >
                                        Request New Link
                                    </button>
                                </div>
                                <br />
                            </div>
                        ) : (
                            <div className="upper_box">
                                <h2>
                                    <span className="mat_icon material-symbols-outlined">group</span> Vendor
                                    Registration Form{' '}
                                </h2>

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <lottie-player
                                        src="https://lottie.host/66b03ae5-ad9c-45f9-95f0-330413ee76fe/fZXsnvWuk6.json"
                                        background="##fff"
                                        speed="1"
                                        style={{ width: '100px', height: '100px' }}
                                        loop
                                        autoplay
                                        direction="1"
                                        mode="normal"
                                    ></lottie-player>
                                    <h6 className="textvendor">Invalid Link</h6>
                                </div>
                                <br />
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}
